import {AfterViewInit, Component, HostBinding, Input} from '@angular/core';
import {Router} from '@angular/router';
import {AppService} from '../../app.service';
import {LayoutService} from '../layout.service';
import {StateService} from '../../state.service';
import {CertificateService} from '../../certificate.service';
import {CertificateStatus} from '../../models/certificate-status.enum';

@Component({
  selector: 'app-layout-sidenav',
  templateUrl: './layout-sidenav.component.html',
  styles: [':host { display: block; }']
})
export class LayoutSidenavComponent implements AfterViewInit {
  @Input() orientation = 'vertical';

  @HostBinding('class.layout-sidenav') hostClassVertical = false;
  @HostBinding('class.layout-sidenav-horizontal') hostClassHorizontal = false;
  @HostBinding('class.flex-grow-0') hostClassFlex = false;

  constructor(private router: Router, private appService: AppService, private layoutService: LayoutService, private stateService: StateService, private certificateService: CertificateService) {
    // Set host classes
    this.hostClassVertical = this.orientation !== 'horizontal';
    this.hostClassHorizontal = !this.hostClassVertical;
    this.hostClassFlex = this.hostClassHorizontal;
  }

  ngAfterViewInit() {
    // Safari bugfix
    this.layoutService._redrawLayoutSidenav();
  }

  getClasses() {
    let bg = this.appService.layoutSidenavBg;

    if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
      bg = bg
        .replace(' sidenav-dark', '')
        .replace(' sidenav-light', '')
        .replace('-darker', '')
        .replace('-dark', '');
    }

    return `${this.orientation === 'horizontal' ? 'container-p-x ' : ''} bg-${bg}`;
  }

  isActive(url) {
    return this.router.isActive(url, true);
  }

  isMenuActive(url) {
    return this.router.isActive(url, false);
  }

  isMenuOpen(url) {
    return this.router.isActive(url, false) && this.orientation !== 'horizontal';
  }

  toggleSidenav() {
    this.layoutService.toggleCollapsed();
  }

  shouldShowCompanies(): boolean {
    return this.stateService.isProfessional();
  }

  shouldShowProfessionals(): boolean {
    return this.stateService.isCompany();
  }

  isCompany(): boolean {
    return this.stateService.isCompany();
  }

  numberOfPendingAccessRequests(): number {
    return this.stateService.getCurrentUser().pendingAccess.length || undefined;
  }

  numberOfOpenVacancies(): number {
    return 1;
  }

  numberOfPendingCertificates(): number {
    let pendingCertificates: number = this.certificateService.getCertificates().filter(cert => cert.status === CertificateStatus.PENDING_APPROVAL).length;
    if(this.stateService.isInstitution() && pendingCertificates > 0) {
      return pendingCertificates;
    }
    return undefined;
  }

}
